import {controller, target} from '@github/catalyst'
import {setCookie} from '@github-ui/cookies'
import {sendEvent} from '@github-ui/hydro-analytics'

const oneWeek = 7 * 24 * 60 * 60 * 1000

@controller
export class LocaleSelectorElement extends HTMLElement {
  @target declare locale: HTMLElement

  handleSelectLocale(e: MouseEvent) {
    e.preventDefault()
    e.stopPropagation()

    if (e.currentTarget instanceof HTMLElement) {
      const locale = e.currentTarget.getAttribute('data-locale')
      if (!locale) {
        return
      }

      // Send hydro analytics event
      sendEvent('select_language.click', {
        category: 'Locale Picker',
        action: 'click_to_select_language',
        label: `locale:${locale}`,
      })

      const expiration = new Date(Date.now() + oneWeek).toUTCString()
      setCookie('locale', locale, expiration)
      this.redirectWithLocaleParam(locale)
    }
  }

  redirectWithLocaleParam(locale: string): void {
    const currentUrl = new URL(window.location.href, window.location.origin)
    currentUrl.searchParams.set('locale', locale)
    window.location.href = currentUrl.toString()
  }
}
